/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { createEnum } from 'fierry/util/enum';


// Index values match the cpp `zone_rule_type` enum order { incentive, penalty }.
export default createEnum('Incentive', 'Penalty');
